export default "__VITE_ASSET__Bv8hFs4j__"